import { render, staticRenderFns } from "./CleaningIssuesReported.vue?vue&type=template&id=3c8529c1&scoped=true"
import script from "./CleaningIssuesReported.vue?vue&type=script&lang=js"
export * from "./CleaningIssuesReported.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8529c1",
  null
  
)

export default component.exports